const LEADING_TOOL_TAG_PATTERN = /^\s*\[[\w./-]+\]\s*/;
const FULL_RESULTS_FOOTER_PATTERN =
  /\n?\s*Full results saved to:\s*\S+\s*\n?\s*Use read_file to access the complete output\.?/g;
const ROUTING_PREAMBLE_PATTERN =
  /^##\s*Analysis Approach[\s\S]*?##\s*Analysis Results\s*/;

export function stripCodeAnalyzerResultArtifacts(content: string): string {
  return content
    .replace(FULL_RESULTS_FOOTER_PATTERN, '')
    .replace(LEADING_TOOL_TAG_PATTERN, '')
    .trim()
    .replace(ROUTING_PREAMBLE_PATTERN, '')
    .trim();
}
